
/* Material */
import useStyles from './Brands.styles'

/* Types */
import { tBrands } from 'src/shared/frontendTypes/brand'

/* Components */
import Brand from './Brand'

interface Props {
  brands: tBrands
}

const Brands: React.FC<Props> = ({ brands }) => {
  const classes = useStyles()

  return <>
    <hr />  
    <div className={classes.cardGrid}>
      {brands?.map(brand => (
        <Brand key={brand.id} brand={brand} />
      ))}
    </div>
  </>

}

export default Brands
